module.exports = __webpack_public_path__ + "img/customer-a-009.e5b22410.png";